import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.bf{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.gs{justify-content:stretch;}.ssr-plugin'
import '.ar{position:sticky;}.ssr-plugin'
import '.as{top:0px;}.ssr-plugin'
import '.ay{z-index:10;}.ssr-plugin'
import '.g8{padding-block:1rem;}.ssr-plugin'
import '.g9{height:3rem;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.ah{flex-wrap:wrap;}.ssr-plugin'
import '.gt{margin-bottom:0px;}.ssr-plugin'
import '.gu{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fr{margin-top:2rem;}.ssr-plugin'
import '.gv{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d r ax e dj"
      >
        <div className="bf d t ax e"
        >
          <div className="ab d e gs ar as ay dj"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="g8 g9 d ae t ah"
            >
              <styled.span className="gt"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="gu d e r fr gv ab"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
